import React from 'react';
import classnames from 'classnames/bind';
import { Button, AutoAwesomeOutlinedIcon, EditOutlinedIcon } from 'tuui';
import { pxToRem } from 'taboola-ultimate-ui';
import { useIsCreativeLibrary } from 'modules/campaigns/hooks/useIsCreativeLibrary';
import {
    getHasPageProductDetails,
    useAiVariationsContext,
} from 'modules/campaigns/modules/creative-creator/components/AiVariationsContextProvider';
import { useHasAiWizardOnboarding } from 'modules/campaigns/modules/creative-creator/components/AiVariationsContextProvider/hooks/useHasAiWizardOnboarding';
import { ReactComponent as ChatAgentIcon } from 'modules/onboarding/OnboardingChatForm/components/InitWidget/welcome-message-icon.svg';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import styles from './helpWriteButton.module.scss';

const classNameBuilder = classnames.bind(styles);

const StarsIcon = () => (
    <AutoAwesomeOutlinedIcon sx={{ fontSize: pxToRem('13px') }} className={classNameBuilder('icon', 'stars')} />
);

const AiIcon = () => <ChatAgentIcon className={classNameBuilder('icon', 'chat-agent')} />;

export const HelpWriteButton = ({ className, size = Button.size.md, variant = Button.variant.outline, onClick }) => {
    const hasAiWizardOnboarding = useHasAiWizardOnboarding();
    const { isCreativeLibraryModule } = useIsCreativeLibrary();
    if (!hasAiWizardOnboarding || isCreativeLibraryModule) {
        return null;
    }
    return (
        <div className={classNameBuilder('container', className)}>
            <Button size={size} variant={variant} className={styles['button']} onClick={onClick}>
                <div className={styles['help-text']}>
                    <HelpWriteText IconComponent={AiIcon} />
                </div>
            </Button>
        </div>
    );
};

export const HelpWriteText = ({ IconComponent = StarsIcon }) => {
    const data = useAiVariationsContext();
    const hasPageProductDetails = getHasPageProductDetails(data);
    return (
        <div className={styles['text-container']}>
            {hasPageProductDetails ? (
                <>
                    <EditOutlinedIcon sx={{ fontSize: pxToRem('13px') }} className={classNameBuilder('icon', 'edit')} />
                    <FormattedMessage id="creative.creator.aiTitleSuggestions.edit" defaultMessage="Edit AI wizard" />
                </>
            ) : (
                <>
                    <IconComponent />
                    <FormattedMessage id="creative.creator.aiTitleSuggestions.help" defaultMessage="Help me write" />
                </>
            )}
        </div>
    );
};
